<template>
  <BaseModal ref="modal" v-model="modalShow" title="Editar Comentario" size="md">
    <AlertDismiss ref="alertDismissInModal"></AlertDismiss>
    <div v-if="modalShow">
      <form @submit.prevent="onSubmitComment">
        <div class="form-group mb-3">
          <label for="conflictComment">Comentario</label>
          <textarea 
            class="form-control" 
            id="conflictComment" 
            v-model="editableComment" 
            rows="5" 
            placeholder="Escriba su comentario aquí...">
          </textarea>
        </div>
        <div class="d-flex justify-content-end gap-2">
          <b-button 
            variant="outline-secondary" 
            @click="discardChanges"
            :disabled="!hasChanges">
            Descartar
          </b-button>
          <b-button 
            type="submit" 
            variant="outline-primary" 
            :disabled="isUploadingForm || !hasChanges">
            <b-spinner small v-if="isUploadingForm"></b-spinner>
            Guardar
          </b-button>
        </div>
      </form>
    </div>
  </BaseModal>
</template>

<script>
import { mapActions } from 'vuex';
import { EventNames } from '@/plugins/enums/index.js';
import BaseModal from '@/components/shared/Base-modal.vue';
import AlertDismiss from '@/components/shared/Alert-dismiss.vue';

export default {
  name: 'FamilyStatementConflictComments',

  components: { BaseModal, AlertDismiss },

  data() {
    return {
      modalShow: false,
      isUploadingForm: false,
      editableComment: '',
      originalComment: '',
      conflictId: null,
    };
  },

  computed: {
    hasChanges() {
      return this.editableComment !== this.originalComment;
    }
  },

  mounted() {
    this.$eventBus.$on(EventNames.OpenModalFamilyStatementConflictComments, (data) => {
      this.conflictId = data.conflictId;
      this.originalComment = data.currentComment || '';
      this.editableComment = data.currentComment || '';
      this.modalShow = true;
    });
  },

  beforeDestroy() {
    this.$eventBus.$off(EventNames.OpenModalFamilyStatementConflictComments);
  },

  methods: {
    ...mapActions(["updateCommentConflictOfInterest"]),
    async onSubmitComment() {
      if (!this.editableComment.trim()) {
        this.$refs.alertDismissInModal.showAlert('El comentario no puede estar vacío.', 'warning', 3000);
        return;
      }
      
      this.isUploadingForm = true;
      const result = await this.updateCommentConflictOfInterest({
        conflictId: this.conflictId,
        comment: this.editableComment,
      });

      if (result.isError) {
        this.$refs.alertDismissInModal.showAlert(result.message, 'danger', 5000);
        return;
      }

      this.$refs.alertDismissInModal.showAlert('Comentario actualizado correctamente.', 'success', 3000);
      this.$eventBus.$emit(EventNames.UpdatedCommentFamilyStatementConflict, { 
        conflictId: this.conflictId, 
        newComment: this.editableComment 
      });
      this.originalComment = this.editableComment;
      this.isUploadingForm = false;
    },
    discardChanges() {
      this.editableComment = this.originalComment;
    },
    closeModal() {
      this.modalShow = false;
      this.editableComment = '';
      this.originalComment = '';
      this.conflictId = null;
    }
  },
};
</script>
